import { type TCreateSourceForm as TApiCreateSourceForm } from '@core/api'

import { type TCreateSourceForm } from '@core/models'

/**
 * Converts TCreateSourceForm from the app to the API TCreateSourceForm model.
 *  @param payload - The TCreateSourceForm type from the app.
 *  @returns The API TCreateSourceForm type
 */
export const convertCreateSourceForm = (payload: TCreateSourceForm): TApiCreateSourceForm => {
    return {
        mime: payload.mime,
        size: payload.size,
        name: payload.name,
        method: payload.method,
    }
}
